// const url = '/test-request/form/:id';
const HEADERS = {
  '/dashboard': {
    titleBold: ['Dashboard and Reports'],
  },
  '/admin/party': {
    titleBold: 'Party',
  },
  '/admin/currency': {
    titleBold: 'Currency',
  },
  '/admin/company': {
    titleBold: 'Company',
  },
  '/admin/location': {
    titleBold: 'Location',
  },
  '/admin/osdreason': {
    titleBold: 'OSD Reason',
  },
  '/admin/modetransport': {
    titleBold: 'Mode of Transport',
  },
  '/admin/tariff': {
    titleBold: 'Tariff',
  },
  '/admin/unitmeasure': {
    titleBold: 'Unit of Measure',
  },
  '/admin/warehouse': {
    titleBold: 'Warehouse',
  },
  '/admin/companies': {
    titleBold: 'Company',
  },
  '/admin/users': {
    titleBold: 'Users',
  },
  '/admin/users/details': {
    titleBold: 'User Details',
  },
  '/admin/eventlogs': {
    titleBold: 'Event Logs',
  },
  '/tools/event-logs': {
    titleBold: 'Logs',
  },
  '/handover-forms': {
    titleBold: 'Handover Forms',
  },
  '/po-parts-labs': {
    titleBold: 'Purchase Order',
  },
  '/add-parts': {
    titleBold: 'Add Parts',
  },
  '/warehouse-in/list': {
    titleBold: 'Warehouse In',
  },
  '/warehouse-out/list': {
    titleBold: 'Warehouse Out',
  },
  '/reports': {
    titleBold: 'Reports',
  },
};

export default HEADERS;
